import React, { useState } from 'react'
import { Button, Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap'

const ClonarJornada = (props) => {

    const [diaAClonar, setDiaAClonar] = useState("L")
    const [listaDiasClonar, setListaDiasClonar] = useState({l: false, m: false, x: false, j: false, v: false, s: false, d:false})

    const handleCheckboxChange = (e) => {
        const { id, checked } = e.target;
        setListaDiasClonar(prevState => ({
            ...prevState,
            [id]: checked
        }));
    };

    const handleClonar =  () =>{
        const origenCopia = props.jornadas.filter((jornada) => jornada.diaSem === diaAClonar)
        let targetCopiar =[]
        if(listaDiasClonar.l){
            targetCopiar = [...targetCopiar ,...origenCopia.map(jornada => ({diaSem: "L", horaEntrada: jornada.horaEntrada, horaSalida: jornada.horaSalida}) )];
        }


        if(listaDiasClonar.m){
            targetCopiar = [...targetCopiar ,...origenCopia.map(jornada => ({diaSem: "M", horaEntrada: jornada.horaEntrada, horaSalida: jornada.horaSalida}) )];
        }

        if(listaDiasClonar.x){            
            targetCopiar = [...targetCopiar ,...origenCopia.map(jornada => ({diaSem: "X", horaEntrada: jornada.horaEntrada, horaSalida: jornada.horaSalida}) )];
        }

        if(listaDiasClonar.j){
            targetCopiar = [...targetCopiar ,...origenCopia.map(jornada => ({diaSem: "J", horaEntrada: jornada.horaEntrada, horaSalida: jornada.horaSalida}) )];
        }

        if(listaDiasClonar.v){
            targetCopiar = [...targetCopiar ,...origenCopia.map(jornada => ({diaSem: "V", horaEntrada: jornada.horaEntrada, horaSalida: jornada.horaSalida}) )];
        }

        if(listaDiasClonar.s){
            targetCopiar = [...targetCopiar ,...origenCopia.map(jornada => ({diaSem: "S", horaEntrada: jornada.horaEntrada, horaSalida: jornada.horaSalida}) )];
        }

        if(listaDiasClonar.d){
            targetCopiar = [...targetCopiar ,...origenCopia.map(jornada => ({diaSem: "D", horaEntrada: jornada.horaEntrada, horaSalida: jornada.horaSalida}) )];
        }

        props.copiarJornada(targetCopiar);
    }

    return (
        <>
            <Form>
                <Container>
                    <FormGroup row>
                        <Label>Día a copiar</Label>
                        <Input type='select' value={diaAClonar} onChange={(e) => setDiaAClonar(e.target.value)}>
                            <option value={"L"}> Lunes</option>
                            <option value={"M"}> Martes</option>
                            <option value={"X"}> Miércoles</option>
                            <option value={"J"}> Jueves</option>
                            <option value={"V"}> Viernes</option>
                            <option value={"S"}> Sábado</option>
                            <option value={"D"}> Domingos</option>
                        </Input>
                    </FormGroup>
                    <FormGroup >
                        <Row><Label>Días destino</Label></Row>
                        <Row>
                            <Col className="custom-control custom-checkbox mb-3">
                                <Input id="l" type='checkbox' checked={listaDiasClonar.l} onChange={handleCheckboxChange}/>
                                <Label>Lunes</Label>
                            </Col>
                            <Col className="custom-control custom-checkbox mb-3">
                                <Input id="m" type='checkbox' checked={listaDiasClonar.m} onChange={handleCheckboxChange}/>
                                <Label>Martes</Label>
                            </Col>
                            <Col className="custom-control custom-checkbox mb-3">
                                <Input id="x" type='checkbox' checked={listaDiasClonar.x} onChange={handleCheckboxChange}/>
                                <Label>Miércoles</Label>
                            </Col>
                            <Col className="custom-control custom-checkbox mb-3">
                                <Input id="j" type='checkbox' checked={listaDiasClonar.j} onChange={handleCheckboxChange}/>
                                <Label>Jueves</Label>
                            </Col>
                            <Col className="custom-control custom-checkbox mb-3">
                                <Input id="v" type='checkbox' checked={listaDiasClonar.v} onChange={handleCheckboxChange}/>
                                <Label>Viernes</Label>
                            </Col>
                            <Col className="custom-control custom-checkbox mb-3">
                                <Input id="s" type='checkbox' checked={listaDiasClonar.s} onChange={handleCheckboxChange}/>
                                <Label>Sábado</Label>
                            </Col>
                            <Col className="custom-control custom-checkbox mb-3">
                                <Input id="d" type='checkbox' checked={listaDiasClonar.d} onChange={handleCheckboxChange}/>
                                <Label>Domingo</Label>
                            </Col>
                        </Row>
                    </FormGroup>
                    <div className='text-right'>

                    <Button onClick={() =>handleClonar()}>Clonar</Button>
                    </div>
                </Container>

            </Form>

        </>
    )
}

export default ClonarJornada